/* import __COLOCATED_TEMPLATE__ from './custom-select.hbs'; */
﻿import Component from '@ember/component';
import { action } from '@ember/object';

import { modifier } from 'ember-modifier';

////////////////////////////////////////////////////////////////////////////////////
// custom-select - This is the Base Dropdown Component used by the application    //
////////////////////////////////////////////////////////////////////////////////////

export default class CustomSelect extends Component {
  tagName = '';

  ////////////////////////////////////////////////////////////////////////////////
  // Modifier                                                                   //
  ////////////////////////////////////////////////////////////////////////////////

  setSelectedValue = modifier((element, [selectedValue]) => {
    element.value = selectedValue.id.toString();
  });

  ////////////////////////////////////////////////////////////////////////////////
  // Component Actions                                                          //
  ////////////////////////////////////////////////////////////////////////////////

  @action onChangeSelect(event) {
    let selectedItem = this.options.find((item) => {
      return item.id.toString() === event.target.value;
    });

    if (this.updateField) {
      this.updateField(this.fieldId, selectedItem);
    }
  }
}
